import { ModalUtil } from './modalUtil';
import { Event, Util } from '..';
import { ILoadable, IKeyBinding, IEventData, IEvent } from '../../interfaces';
import { ModalOptions } from '../../interfaces/options';
import { KeyCode } from '../../enums';
import { DefaultModalOptions } from '../../const/defaultOptions';
import { Localization } from '../../compile';

export class Modal implements ILoadable {
	protected id: string;
	private title: string;
	private height: KnockoutObservable<string>;
    private width: KnockoutObservable<string>;
    private minWidth: KnockoutObservable<string>;
	private visible: KnockoutObservable<boolean>;
	private node: Node;
	public contentTemplate: KnockoutObservable<string>;
	public template: KnockoutObservable<string>;
	private keyBindings: IKeyBinding[];
	private closeLabel: string;
	private applyLabel: string;

	//#region click bindings
	private clickClose: () => void;
	private clickOpen: () => void;
	//#endregion

	//#region Events
	private onCloseHandling: Event<void>;

	private onBeforeClosed: Event<IEventData>;
	public get BeforeClosed(): IEvent<IEventData> {
		return this.onBeforeClosed;
	}

	private onClosed: Event<void>;
	public get Closed(): IEvent<void> {
		return this.onClosed;
	}

	private onOpened: Event<void>;
	public get Opened(): IEvent<void> {
		return this.onOpened;
	}
	//#endregion

	constructor(options?: ModalOptions) {
		options = $.extend(true, {}, DefaultModalOptions, options || {});

		this.id = options.id || ModalUtil.getNewId();
		this.title = options.title || '';
		this.contentTemplate = ko.observable<string>(options.contentTemplate);
		this.template = ko.observable<string>(options.template);
		this.closeLabel = options.closeLabel || Localization.Cancel;
		this.applyLabel = options.applyLabel || Localization.Apply;

		this.height = ko.observable(options.height);
        this.width = ko.observable(options.width);
        this.minWidth = ko.observable(options.minWidth);
		this.visible = ko.observable(false);
		this.node = null;
		this.keyBindings = <IKeyBinding[]>[];
		this.keyBindings.push({ keyCode: KeyCode.ESCAPE, fn: this.close, thisArg: this });

		if (options.keyBindings && options.keyBindings.length > 0) {
			options.keyBindings.forEach(keyBinding => {
				if (!keyBinding.thisArg) {
					keyBinding.thisArg = this;
				}
			});
			this.keyBindings = this.keyBindings.concat(options.keyBindings);
		}

		//#region click bindings
		this.clickClose = () => {
			this.close();
		};

		this.clickOpen = () => {
			this.open();
		};
		//#endregion

		//#region Events
		this.onCloseHandling = new Event<void>();
		this.onBeforeClosed = new Event<IEventData>();
		this.onClosed = new Event<void>();
		this.onOpened = new Event<void>();

		this.onCloseHandling.subscribe(() => {
			var closedEventData: IEventData = {
				preventDefault: false
			};

			this.onBeforeClosed.notify(closedEventData);

			if (!closedEventData.preventDefault) {
				this.forceClose();
			}
		});
		//#endregion
	}

	public open(...args: any[]): void {
		ModalUtil.overlay();
		ModalUtil.chain(this);
	}

	public close(): void {
		if (this.visible()) {
			this.onCloseHandling.notify();
		}
	}

	public show() {
		this.visible(true);
		this.bindKeys();
		this.onOpened.notify();
	}

	public hide() {
		this.visible(false);
		this.unbinKeys();
	}

	public loading(state: boolean = true) {
		Util.loading(state, '#' + this.id);
	}

	private forceClose(): void {
		this.hide();
		ModalUtil.overlay(false);
		this.onClosed.notify();
	}

	private bindKeys(): void {
		Util.bindKeys(this.keyBindings);
	}

	private unbinKeys(): void {
		Util.unbindKeys(this.keyBindings);
	}
}
